<template>
  <div class="my-item">
    <div class="my-item-box2" v-if="downList && downList.length">
      <Row :gutter="30">
        <Col
          :sm="12"
          :md="6"
          v-for="(item, index) in downList"
          :key="'downList-' + index"
          class="w-20"
        >
          <div class="mib">
            <img :src="fileName(item.path)" />
            <p :title="item.name">{{item.name}}</p> 
            <a :href="item.path" :download="item.name" target="_blank">Download</a>
          </div>
        </Col>
      </Row>
      <div class="my-page" v-if="totalCount > pageSize">
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
        />
      </div>
    </div>
    <div class="u-empty" v-else>No data</div>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import { mapActions, mapGetters } from "vuex";
import Docx from "@assets/img/type/docx.png";
import Png from "@assets/img/type/png.png";
import Jpg from "@assets/img/type/jpg.png";
import Pdf from "@assets/img/type/pdf.png";
import Ppt from "@assets/img/type/ppt.png";
import Txt from "@assets/img/type/txt.png";
import Unkown from "@assets/img/type/unknow.png";
import Xls from "@assets/img/type/xls.png";
import Zip from "@assets/img/type/zip.png";

export default {
  name: "exhibition-down-item",
  data() {
    return {
      downList: null,

      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      timer: null
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    },
    imgArr() {
      return {
        doc: Docx,
        docx: Docx,
        png: Png,
        jpg: Jpg,
        jpeg: Jpg,
        pdf: Pdf,
        ppt: Ppt,
        pptx: Ppt,
        txt: Txt,
        unkown: Unkown,
        xls: Xls,
        xlsx: Xls,
        zip: Zip
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getDownByExhibition: "hostDownModule/getDownByExhibition",
      getProduct: "productModule/getProduct",
      delProduct: "productModule/delProduct"
    }),
    async init() {
      let result = await this.getDownByExhibition(this.exhibition.id); 
      if (result.length) {
        let arr = [];
        result.map(c => {
          if (c.typeId === 1) {
            arr.push(c);
          }
        })
        this.downList = arr;
      } else {
        this.downList = [];
      }
      // this.downList = result;
      this.totalCount = result.length;
      // console.log(result);
    },
    fileName(file) {
      if (!file) return;
      //截取文件后缀
      let file_name = file.substring(file.lastIndexOf(".") + 1);
      let name = this.imgArr[file_name];
      return name ? name : this.imgArr["unkown"];
    },
  }
};
</script>

<style scoped lang="scss">
.my-item {
  min-width: 600px;
  padding: 30px;

  &-box2 {
    margin-bottom: 30px;
    min-height: 400px;
  }

  .mib {
    background-color: #fff;
    height: 340px;
    box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
    font-size: 16px;
    color: #333;
    padding: 78px 10px 0;
    text-align: center;
    margin-bottom: 20px;
    img {
      width: 90px;
      display: inline-block;
      margin-bottom: 38px;
    }
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 38px;
    }
    a {
      font-size: 20px;
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
}
</style> 
